import { Component, ViewChild } from '@angular/core';
import { LightgalleryComponent } from 'lightgallery/angular';
import { BeforeSlideDetail } from 'lightgallery/lg-events';
import { LightGallery } from 'lightgallery/lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { DEFAULT_IMAGE } from 'src/app/core/constant/constant';
import { assetsModel } from 'src/app/core/models/assets.model';
import { CategoryService } from 'src/app/data/services/category.service';
import { ProductDetailModalComponent } from 'src/app/layout/modals/product-detail-modal/product-detail-modal.component';
import { Helper } from 'src/app/shared/helper';
// import { AssetsService } from 'src/app/data/services/assets.service';
import { environment } from 'src/environments/environment';
import { AuthComponent } from '../../auth/auth.component';
import { LanguageService } from 'src/app/shared/language.service';

@Component({
	selector: 'app-properties',
	templateUrl: './properties.component.html',
	styleUrls: ['./properties.component.scss']
})
export class PropertiesComponent {
	current_page: number = 1;
	items_per_page: number = 10;
	selected_tab: number = 1;
	assetsList: assetsModel[] = [];
	imageUrl = environment.IMAGE_URL;
	DEFAULT_IMAGE = DEFAULT_IMAGE;

	private lightGallery!: LightGallery;
	private needRefresh = false;
	items: any[] = [];
	settings = {
		counter: false,
		dynamic: true,
		dynamicEl: this.items,
		plugins: [lgZoom, lgThumbnail]
	};

	selectedFilter: number = 1;

	filters = [
		{ id: 1, name: 'label-title.ascending-order' },
		{ id: 2, name: 'label-title.descending-order' },
		{ id: 3, name: 'label-title.price-low-to-high' },
		{ id: 4, name: 'label-title.price-high-to-low' },
	];
	searchText: any = '';
	previousSearchedText: any;
	categoryList: any[] = [];
	productList: any[] = [];
	selectedCategory: any = null;
	page: number = 1; // Start with page 1
	limit: number = 8; // Initial limit is 8 products
	totalProducts: number = 0; // Store total product count

	hoveredProductId!: string;  // Holds the current image during hover

	@ViewChild('productDetailModal', { static: false })
	productDetailModal!: ProductDetailModalComponent;
	@ViewChild('lightbox', { static: false }) lightbox?: LightgalleryComponent;
  	@ViewChild('authModel', { static: false }) authModel!: AuthComponent;

	constructor(
		private categoryService: CategoryService,
		public helper: Helper,
		private languageService: LanguageService
	) {
		// Refresh categories when language changes
		this.languageService.languagesObservable.subscribe((data) => {
			if (data) {
				this.getCategoryList();
			}
		});
	}

	ngOnInit() {
		setTimeout(() => {
			if(this.helper.userDetails){
				this.getCategoryList();
			}else{
				this.authModel.open();
			}
		}, 800);
	}

	isLogin(evt:any):void{
		if(evt){
			this.getCategoryList();
		}
	}

	onSearch(): void {
		this.searchText = this.searchText.trim();
		if (this.searchText !== this.previousSearchedText) {
		  this.previousSearchedText = JSON.parse(JSON.stringify(this.searchText));
		  this.getCategoryList();
		}
	  }
	
	  clearSearch(): void {
		this.searchText = "";
		this.getCategoryList();
	  }

	getCategoryList(): Promise<void> {
		const parameters = { page: 1, limit: 1000, sortField: 'sortOrder', sortOrder: 1,searchText:this.searchText, useLocalizedFields: true, isActive: true }
		return new Promise((resolve, reject) => {
			this.categoryService.getCategoryList(parameters).subscribe((response: any) => {
				if (response?.data?.categories?.length > 0) {
					this.categoryList = response.data.categories;
					this.selectedCategory = this.categoryList[0];
					if (this.helper.selectedCategory?._id) {
						this.selectedCategory = this.categoryList.find(category => category._id === this.helper.selectedCategory?._id);
						this.selectCategoryWiseProductList(this.selectedCategory);
					} else if (this.selectedCategory) {
						this.selectCategoryWiseProductList(this.selectedCategory);
					}
				} else {
					this.categoryList = [];
					this.productList = [];
				}
				resolve();
			});
		});
	}

	selectCategoryWiseProductList(category: any, loadMore: boolean = false): Promise<void> {
		if (!this.helper.userDetails) {
			return Promise.resolve();
		}
		if (!loadMore) {
			this.page = 1;
			this.totalProducts = 0;
		}
		this.selectedCategory = category;
		const parameters = {
			page: this.page,
			limit: this.limit,
			sortField: 'sortOrder',
			sortOrder: 1,
			id: category._id,
			useLocalizedFields: true,
			isActive: true
		};

		return new Promise((resolve, reject) => {
			this.categoryService.getCategoryWiseProductList(parameters).subscribe((response: any) => {
				this.totalProducts = response?.dataCount; // Assume API returns total product count

				if (response?.products?.length > 0) {
					if (loadMore) {
						const categoryData = response;
						// Append new products to the existing list without replacing
						this.productList = [...this.productList, ...categoryData.products];
					} else {
						// Load the initial products
						this.productList = response.products;
					}
				} else {
					if (!loadMore) {
						this.productList = [];
						this.totalProducts = 0;
					}
				}
				resolve();
			});
		});
	}

	loadMoreProducts() {
		this.page++; // Increment the page number
		this.selectCategoryWiseProductList(this.selectedCategory, true); // Pass true to append products
	}

	applyFilter(): void {
		const sortBy = this.selectedFilter;
		if (sortBy === 1) {
			// Sort by name in ascending order
			this.productList.sort((a, b) => a.name.localeCompare(b.name));
		} else if (sortBy === 2) {
			// Sort by name in descending order
			this.productList.sort((a, b) => b.name.localeCompare(a.name));
		} else if (sortBy === 3) {
			// Sort by price: low to high
			this.productList.sort((a, b) => a.price - b.price);
		} else if (sortBy === 4) {
			// Sort by price: high to low
			this.productList.sort((a, b) => b.price - a.price);
		}
	}


	get_assets_list() {
		let json: any = {
			page: this.current_page,
			limit: this.items_per_page,
			isApprove: this.selected_tab
		}
	}

	openGallery(asset: any) {
		if (asset.assetsImage.length > 0) {
			this.items = [];
			asset.assetsImage.forEach((image: any, index: any) => {
				this.items.push({ id: index, src: this.imageUrl + 'assetsImage/' + image, thumb: this.imageUrl + 'assetsImage/' + image })
			});

			this.lightGallery.refresh(this.items);
			this.lightGallery.openGallery();
			this.needRefresh = false;
		}
	};

	viewProduct(product: any): void {
		this.productDetailModal.open(product._id);
		// this.helper._route.navigate(['/app/product-detail/', product._id]); // Pass the product ID
	}

	// Update current image on hover
	onHover(product: any): void {
		if(product.images.length > 0) {
		this.hoveredProductId = product._id;  // Set the ID of the hovered product
		}
	}

	// Reset hovered product ID on hover out
	onHoverOut(): void {
		this.hoveredProductId = '';  // Reset hovered product ID
	}

}
